import CardPreviewRow from './card-preview-row';

export default CardPreviewRow;